import { Fold, Lens, Traversal, Getter, } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as RA from "fp-ts/ReadonlyArray";
export const _Show2DefaultImageAttributes = Fold.compose(Optics._Show2Images, Optics._ImageOfKind("default"), Res._Response(), Lens.prop("attributes"));
export const _Show2PosterImageAttributes = Fold.compose(Optics._Show2Images, Optics._ImageOfKind("poster"), Res._Response(), Lens.prop("attributes"));
export const _Show2Route = Fold.compose(Optics._ShowGetter, Res._Rel("routes"), Res._Response(), Fold._each(), Lens.path("attributes", "url"));
export const _Show2Packages = Fold.compose(Optics._ShowGetter, Res._Rel("contentPackages"), Res._Response(), Fold._each(), Traversal._filtered((packages) => packages.id === "DiscoveryPlusMain"), Lens.prop("id"));
const _Show2Id = Fold.compose(Optics._Show2Data, Lens.prop("id"));
const _ShowGenres = Fold.compose(Optics._ShowGetter, Optics._Show2TxGenres, Optics._TxNodeAttributes2Name, M._Just());
const _ShowCategory = Fold.compose(Optics._ShowGetter, Res._Rel("txGenres"), Res._Response(), Fold.mapF((data) => data.map((item) => Fold.preview(Fold.compose(Getter.of(), Lens.path("attributes", "name"), M._Just()), item))), Fold.mapF(RA.compact));
const _Show2PrimaryChannel = Fold.compose(Optics._ShowGetter, Res._Rel("primaryChannel"), Res._Response(), Lens.path("attributes", "alternateId"));
const _Show2MinimumAge = Fold.compose(Optics._ShowGetter, Res._Response(), Lens.path("attributes", "minimumAge"), M._Just());
export const _Video2Id = Fold.compose(Optics._Video2Data, Lens.prop("id"));
const _Video2ShowName = Fold.compose(Optics._VideoGetter, Res._Rel("show"), Optics._Show2Attributes, Lens.prop("name"));
const _VideoGenres = Fold.compose(Optics._VideoGetter, Optics._Video2TxGenres, Optics._TxNodeAttributes2Name, M._Just());
const _VideoCategory = Fold.compose(Optics._VideoGetter, Res._Rel("txGenres"), Res._Response(), Fold.mapF((data) => data.map((item) => Fold.preview(Fold.compose(Getter.of(), Lens.path("attributes", "name"), M._Just()), item))), Fold.mapF(RA.compact));
const _Video2PrimaryChannel = Fold.compose(Optics._VideoGetter, Res._Rel("show"), Res._Rel("primaryChannel"), Res._Response(), Lens.path("attributes", "alternateId"));
const _Video2MinimumAge = Fold.compose(Optics._VideoGetter, Res._Response(), Lens.path("attributes", "minimumAge"), M._Just());
const _Video2PosterImageAttributes = Fold.compose(Optics._Video2Images, Optics._ImageOfKind("poster"), Res._Response(), Lens.prop("attributes"));
export const _Video2DefaultImageAttributes = Fold.compose(Optics._Video2Images, Optics._ImageOfKind("default"), Res._Response(), Lens.prop("attributes"));
export const _Video2Route = Fold.compose(Optics._VideoGetter, Res._Rel("routes"), Res._Response(), Fold._each(), Lens.path("attributes", "url"));
export const _Video2Packages = Fold.compose(Optics._VideoGetter, Res._Rel("contentPackages"), Res._Response(), Fold._each(), Traversal._filtered((packages) => packages.id === "DiscoveryPlusMain"), Lens.prop("id"));
export const _VideoDetails = Fold.liftM((attributes, image, route, packages, id, primaryChannel, minimumAgeM, genre, posterImageM, showName, contentGenre) => ({
    name: attributes.name,
    packagesM: attributes.packages,
    descriptionM: attributes.description,
    episodeNumberM: attributes.episodeNumber,
    viewingHistoryM: attributes.viewingHistory,
    seasonNumberM: attributes.seasonNumber,
    isFavoriteM: attributes.isFavorite,
    durationM: attributes.videoDuration,
    seasonsM: M.of([]),
    playerType: "VIDEO",
    category: "video",
    videoType: attributes.videoType,
    isNewEpisodeM: attributes.isNew,
    alternateId: attributes.alternateId,
    audioTracks: attributes.audioTracks,
    contentRatingM: attributes.contentRatings,
    contentDescriptorsM: attributes.contentDescriptors,
    identifiers: "",
    image,
    route,
    packages: M.fromMaybe(packages, ""),
    id,
    primaryChannel,
    minimumAgeM,
    genre,
    posterImageM,
    showName,
    contentGenre,
}), Optics._Video2Attributes, _Video2DefaultImageAttributes, _Video2Route, Fold.pre(_Video2Packages), _Video2Id, Fold.pre(_Video2PrimaryChannel), Fold.pre(_Video2MinimumAge), Fold.pre(_VideoGenres), Fold.pre(_Video2PosterImageAttributes), _Video2ShowName, Fold.pre(_VideoCategory));
export const _ShowDetails = Fold.liftM((attributes, image, route, packages, id, primaryChannel, minimumAgeM, genre, posterImageM, contentGenre) => ({
    name: attributes.name,
    packagesM: M.of([""]),
    descriptionM: attributes.description,
    episodeNumberM: M.of(0),
    seasonNumberM: M.of(0),
    seasonsM: attributes.seasonNumbers,
    isFavoriteM: attributes.isFavorite,
    playerType: "",
    category: "Show",
    videoType: M.of(""),
    isNewEpisodeM: attributes.hasNewEpisodes,
    audioTracks: M.of([""]),
    identifiers: attributes.analyticsId,
    alternateId: attributes.alternateId,
    contentRatingM: attributes.contentRatings,
    contentDescriptorsM: attributes.contentDescriptors,
    image,
    route,
    packages: M.fromMaybe(packages, ""),
    id,
    primaryChannel,
    minimumAgeM,
    genre,
    posterImageM,
    showName: "",
    contentGenre,
}), Optics._Show2Attributes, _Show2DefaultImageAttributes, _Show2Route, Fold.pre(_Show2Packages), _Show2Id, Fold.pre(_Show2PrimaryChannel), Fold.pre(_Show2MinimumAge), Fold.pre(_ShowGenres), Fold.pre(_Show2PosterImageAttributes), Fold.pre(_ShowCategory));
export const _emptyResonpnse = Fold.compose(Getter.of(), Res._Error(), Fold._each(), Lens.prop("status"), M._Just());
export const _Col2CollectionitemImage = Fold.compose(Optics._Col2Items, Res._Rel("image"), Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes"));
const _CustomAtrributeGetter = Getter.of();
export const _CustomAttribute2Attributes = Fold.compose(_CustomAtrributeGetter, Optics._Response2ResponseData(), Res._Response(), Lens.prop("attributes"), M._Just());
export const _ShowsCollection = Fold.compose(Optics._Col2Items, Res._Rel("show"), _ShowDetails);
export const _VideosCollection = Fold.compose(Optics._Col2Items, Res._Rel("video"), _VideoDetails);
export const _ShowAndVideoCollection = Fold.alt(_ShowsCollection, _VideosCollection);
export const _VideosCollectionFromSonicApi = Fold.compose(Optics._VideosResponse2Videos, Res._ForEach(), _VideoDetails);
export const _ShowsCollectionFromSonicApi = Fold.compose(Optics._ShowsResponse2Shows, Res._ForEach(), _ShowDetails);

